import Vue from 'vue'
import Login from './Login.vue'

Vue.config.productionTip = false

new Vue({
    el: "#app",
    render: h => h(Login)
})